import { FC } from "react";
import cx from "classnames";
import styles from "./vehicle-type.styles.module.scss";
import { TransitStatus, Vehicle, VehicleType } from "@/types/vehicle";

interface IVehicleTypeView {
  vehicle: Vehicle;
  vehicleStatus: string;
  className?: string;
}

const VehicleTypeView: FC<IVehicleTypeView> = ({ vehicle, vehicleStatus, className }) => (
  <span
    className={cx(styles.container, className, {
      [styles.new]: vehicle.type === VehicleType.NEW && vehicle.transitStatus !== TransitStatus.IN_TRANSIT,
      [styles.used]: vehicle.type === VehicleType.USED,
    })}
  >
    {vehicleStatus}
  </span>
);

export default VehicleTypeView;
